import PropTypes from "prop-types";
import './DishOptions.scss';

const DishOptions = ({options}) => {
    return options.map(({title, values}) => (
        <div
            key={title}
            className="dish-options"
        >
            <div>{title}:</div>
            <div className="dish-options__values">{values.join(', ')}</div>
        </div>
    ));
}

DishOptions.propTypes = {
    options: PropTypes.array
};

DishOptions.defaultProps = {
    options: []
}

export default DishOptions;
